import {useSelector} from 'react-redux'

/**
 * Hook for custom integrations that have their own internal
 * naming conventions. 
 * Eg. The MAX challenge uses 'center' where fitsw uses 'gym' similarly 'member' for 'client'
 */
const useAccountTypeName = (type) => {
    const isMAXUser = useSelector(state => Boolean(state.users?.current_user?.isMAXUser))
	if(isMAXUser){
		return {
			gym:'Center',
			clients:'Members',
			client:'member',
            trainer: 'Trainer',
            chain:'Chain'
		}[type]
	}else{
		return type
	}
}

export default useAccountTypeName